// Morning Briefing — the small line icons (inline SVG, currentColor).
import React from 'react';

const P = (d, w = 1.5) => <path d={d} fill="none" stroke="currentColor" strokeWidth={w} strokeLinecap="round" strokeLinejoin="round" />;
const S = ({ children }) => <svg viewBox="0 0 16 16" aria-hidden="true">{children}</svg>;

export const IcOpen = () => <S>{P('M6.2 3.6h6.2v6.2M12.1 3.9 3.8 12.2')}</S>;
export const IcCheck = () => <S>{P('M3.4 8.6 6.5 11.6 12.6 4.6', 1.7)}</S>;
export const IcMoon = () => <S>{P('M12.8 9.9A5.2 5.2 0 0 1 6.1 3.2a5.2 5.2 0 1 0 6.7 6.7Z', 1.4)}</S>;
export const IcChev = () => <S>{P('M4 6.2 8 10.2l4-4', 1.7)}</S>;
export const IcX = () => <S>{P('M3.5 3.5l9 9M12.5 3.5l-9 9', 1.6)}</S>;
export const IcClock = () => <S><circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="1.4" />{P('M8 4.8V8l2.2 1.4', 1.4)}</S>;
export const IcZoom = () => <S><circle cx="7" cy="7" r="4.2" fill="none" stroke="currentColor" strokeWidth="1.5" />{P('M10.2 10.2 13.4 13.4M5.2 7h3.6M7 5.2v3.6', 1.5)}</S>;
